<template>
  <div class="card-box product-orders">
    <div class="header-switch">
      <p :class="{ active: state === null }">
        <span @click="stateChangeAction(null)">{{ $t("order.tab1") }}</span>
      </p>
      <p :class="{ active: state === 10 }">
        <el-badge :value="waitBuyerPaymentCount" class="item">
          <span @click="stateChangeAction(10)">{{ $t("order.tab2") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state === 20 }">
        <el-badge :value="sendCount" class="item">
          <span @click="stateChangeAction(20)">{{ $t("order.tab3") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state === 30 }">
        <el-badge :value="alreadySentCount" class="item">
          <span @click="stateChangeAction(30)">{{ $t("order.tab4") }}</span>
        </el-badge>
      </p>
      <p :class="{ active: state === 1 }">
        <span @click="stateChangeAction(1)">{{ $t("order.tab5") }}</span>
      </p>
      <p :class="{ active: state === 4 }">
        <span @click="stateChangeAction(4)">{{ $t("order.tab6") }}</span>
      </p>
    </div>
    <div class="page-action-box">
      <div class="btns">
        <el-button
          type="primary"
          round
          plain
          size="mini"
          v-if="(state === 20 || state === 30) && selectedRow.length >= 1"
          @click="updateExpressDialogVisible = true"
          >{{ $t("order.batch") }}</el-button
        >
      </div>
      <div class="pages">
        <p style="margin-right:20px;">
          {{
            $t("order.totalOrder", {
              number: count
            })
          }}
        </p>
        <el-button
          type="primary"
          round
          size="mini"
          style="margin-right:10px;"
          :disabled="page === 1"
          @click="previousPageAction"
          >{{ $t("order.previous") }}</el-button
        >
        <p style="margin-right:10px;">
          <span>{{ page }}</span>
          /{{ lastPage }}
        </p>
        <el-button
          type="primary"
          round
          size="mini"
          :disabled="page === lastPage || lastPage === 0"
          @click="nextPageAction"
          >{{ $t("order.next") }}</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="table-header layout">
        <div class="col-3">{{ $t("order.col1") }}</div>
        <div class="col-1">{{ $t("order.col2") }}</div>
        <div class="col-1">{{ $t("order.col3") }}</div>
        <!-- <div class="col-1">买家</div> -->
        <div class="col-1">{{ $t("order.col4") }}</div>
        <div class="col-1">{{ $t("order.col5") }}</div>
        <div class="col-1">{{ $t("order.col6") }}</div>
      </div>
      <!-- <div class="section" v-for="order in contents" :key="order.OrderNumber"> -->
      <div
        class="section"
        v-for="(order, orderindex) in contents"
        :key="orderindex"
      >
        <div class="header">
          <!-- <el-checkbox v-if="state === 4 || state === 1"></el-checkbox> -->
          <!-- <span>订单号：{{ order.OrderNumber }}</span> -->
          <span>{{ $t("order.orderNumber") }}：{{ order.AllOrderNumber }}</span>
          <!-- <span>创建时间：{{ order.CreateTimeTS | formatDate('YYYY-MM-DD HH:mm:ss') }}</span> -->
          <span>{{ $t("order.createTime") }}：{{ order.CreateTime }}</span>
          <!-- <section class="allPrice">
            <span class="allPriceTitle">总金额：</span>
            <span class="allPriceNum">${{ order.AllPrice }}</span>
          </section>-->
          <section class="allPrice">
            <span class="allPriceTitle">{{ $t("order.allPrice") }}：</span>
            <span class="allPriceNum">${{ order.AllPrice }}</span>
          </section>
          <!-- 2019-10-22 12:22 -->
        </div>
        <!-- <div class="row layout" v-for="product in order.OrderProductsList" :key="product.OrderProductNumber"> -->
        <div
          v-for="(product1, productIndex1) in order.OrderList"
          :key="productIndex1"
        >
          <div
            class="row layout"
            v-for="(product, productIndex) in product1.OrderProductsList"
            :key="productIndex"
          >
            <div class="col-3 product">
              <el-checkbox
                v-model="product.isChecked"
                v-if="state === 20 || state === 30"
                @change="
                  selectRow(
                    $event,
                    product.OrderNumber,
                    product.OrderProductNumber
                  )
                "
              ></el-checkbox>
              <el-image
                class="img"
                :src="product.ProductPhoto | firstImageSrc"
                fit="cover"
              ></el-image>
              <div class="content">
                <img
                  src="@/assets/img/shopManage/icon_label.png"
                  v-if="product.IsTB === 1"
                  class="labelimg"
                />
                <p class="title">{{ product.ProductName }}</p>
                <p class="class">
                  {{ $t("order.specification") }}：{{ product.ProductModelStr }}
                </p>
                <p class="id">ID：{{ product.OrderProductNumber }}</p>
              </div>
            </div>
            <div class="col-1 price">
              ${{ product.C_CustomerIncome | formatPrice }}
            </div>
            <div class="col-1 count">{{ product.Number }}</div>
            <!-- <div class="col-1 buyer">{{ order.NikeName }}</div> -->
            <div class="col-1 buyer">
              <div v-if="state === 20 || state === 30 || state === 1">
                <el-input
                  :placeholder="$t('order.inputExpress')"
                  size="mini"
                  v-model="product.freightInputValue"
                  v-if="product.freightInputVisible"
                  :ref="product.freightInputRef"
                  @keyup.enter.native="productFreightInputConfirm(product)"
                  @blur="productFreightInputConfirm(product)"
                ></el-input>
                <p
                  v-else
                  class="freight"
                  @click="showPorductFreightAction(product)"
                >
                  {{
                    product.PostNumber.length
                      ? $t("order.expresNumber") + ":" + product.PostNumber
                      : $t("order.inputExpress")
                  }}
                </p>
                <div class="noToPay" v-if="product.PostNumber.length == ''">
                  ({{ $t("order.noToPay") }})
                </div>
              </div>

              <p
                class="detail"
                v-if="state === 10 || state === 20"
                @click="closeOrderBtn(product.OrderNumber)"
              >
                {{ $t("order.closeOrder") }}
              </p>
            </div>
            <div class="col-1 state">
              <p>{{ product1.State | statusFil }}</p>
              <p class="detail" @click="getProductInfo(product.OrderNumber)">
                {{ $t("order.detail") }}
              </p>
            </div>
            <div class="col-1 money">
              <!-- <p class="m">${{product.Number*product.PayProductPrice | formatPrice}}</p> -->
              <p class="m">${{ product.C_CustomerRecTotal | formatPrice }}</p>
              <!-- <p class="freight">(含快递：$20.99)</p> -->
              <p
                class="logistics"
                v-show="product.PostNumber"
                @click="getProductInfo(product.OrderNumber)"
              >
                {{ $t("order.viewLogistics") }}
              </p>
              <p
                class="print"
                v-show="product.PostNumber && state == 20"
                @click="printTagAction(product)"
              >
                {{ $t("order.printTag") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="not-more-data" v-show="!contents || !contents.length">
        {{ $t("order.noData") }}
      </div>
    </div>
    <!-- 打印标签 -->
    <el-dialog :title="$t('order.printTag')" :visible.sync="dialogVisible">
      <div class="tag-image-dialog" ref="print">
        <el-image
          id="printMe"
          class="img"
          :src="tagImageSrc | imageSrc"
          fit="contain"
        ></el-image>
        <div class="btn-box">
          <el-button
            type="primary"
            round
            class="btn"
            @click="printTagImageAction"
            v-print="'#printMe'"
            >{{ $t("order.printTag") }}</el-button
          >
          <el-button round class="btn" @click="dialogVisible = false">{{
            $t("order.cancel")
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 批量更新快递单号 -->
    <el-dialog
      :title="$t('order.batch')"
      :visible.sync="updateExpressDialogVisible"
      width="30%"
      :show-close="false"
    >
      <span>{{ $t("order.inputExpressNumber") }}</span>
      <div style="margin-top:20px">
        <el-input clearable v-model="mergeExpressNo"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExpressDialogVisible">{{
          $t("order.cancel")
        }}</el-button>
        <el-button type="primary" @click="updateExpress">{{
          $t("order.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 关闭订单 -->
    <el-dialog
      :title="$t('order.tips')"
      :visible.sync="closeOrderDialogVisible"
      width="30%"
      :show-close="false"
    >
      <div style="margin-top:20px">
        <!-- <el-input v-model="resonForCloseOrder" maxlength="20" show-word-limit></el-input> -->
        <el-select
          style="width:100%"
          v-model="resonForCloseOrder"
          :placeholder="$t('order.reason')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCloseOrderDialogVisible">{{ $t("order.cancel") }}</el-button>
        <el-button type="primary" @click="confirmCloseOrderDialogVisible"
          >{{ $t("order.confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ProductOrders",
  data() {
    return {
      // 1. 已下架Off-shelves
      // 2. 无库存Out of stock
      // 3. 价格失效Price invalidation
      // 4. 产品召回Product recall
      options: [
        {
          value: "Off-shelves",
          label: "Off-shelves"
        },
        {
          value: "Out of stock",
          label: "Out of stock"
        },
        {
          value: "Price invalidation",
          label: "Price invalidation"
        },
        {
          value: "Product recall",
          label: "Product recall"
        }
      ], //关闭订单原因
      closeOrderNumber: "", //需要关闭订单的订单号
      resonForCloseOrder: "", //关闭订单原因
      closeOrderDialogVisible: false, //控制关闭订单弹窗
      mergeExpressNo: "", //批量更新快递单号
      updateExpressDialogVisible: false, //控制更新快递单号弹窗
      checkList: "",
      selectedRow: [],
      sendCount: null, // 等待发货badge
      waitBuyerPaymentCount: null, // 等待买家付款badge
      alreadySentCount: null, // 已发货badge
      state: this.$route.query.state ? this.$route.query.state : null, // null => 全部; 24 => 等待买家付款; 20 => 等待发货; 30 => 已发货; 1 => 成功的订单; 4 => 关闭的订单
      page: 1,
      count: 0,
      lastPage: 0,
      contents: null,
      dialogVisible: false,
      tagImageSrc: "",
      printMe: {
        id: "printMe",
        popTitle: "打印标签",
        extraCss: "https://www.google.com,https://www.google.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      }
    };
  },
  filters: {
    // 状态
    statusFil: function(value) {
      let status = "";
      value = JSON.stringify(value);
      switch (value) {
        case "0":
          status = "发起交易";
          break;
        case "1":
          status = "交易完成(关闭订单)";
          break;
        case "20":
          status = "客户已付款(等待发货)";
          break;
        case "24":
          status = "客户未付款";
          break;
        case "30":
          status = "已发货";
          break;
        case "34":
          status = "仓库退回";
          break;
        case "40":
          status = "取消";
          break;
        case "41":
          status = "买家取消";
          break;
        case "42":
          status = "逾期取消";
          break;
        case "43":
          status = "订单无效取消";
          break;
        case "50":
          status = "客户签收";
          break;
        case "54":
          status = "客户拒签";
          break;
        default:
          status = "未知状态(请查询)";
      }
      return status;
    }
  },
  watch: {
    $route(to, from) {
      this.request(to.query.state, this.page);
    }
  },
  created() {
    this.request(this.state, this.page);
    this.sendBadge();
    this.waitBuyerPaymentCountBadge();
    this.alreadySentCountBadge();
    this.getCount();
  },
  methods: {
    ...mapActions({ getCount: "getMessageCount" }),
    request(state, page) {
      const param = {
        PageIndex: page,
        PageSize: 10
      };
      if (state !== null) {
        param.ScreenValues = state;
      }
      this.$api.order
        .loadOrderByPage(param)
        .then(res => {
          console.log(res, "res");
          this.state = state;
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          // this.contents = res.data.map(order => {
          //   order.OrderProductsList = order.OrderProductsList.map(product => {
          //     product.freightInputVisible = false
          //     product.isChecked = false
          //     product.freightInputValue = product.PostNumber
          //     product.freightInputRef = 'input' + product.OrderProductNumber
          //     return product
          //   })
          //   return order
          // })
          for (let i in res.data) {
            res.data[i].OrderList.map(order => {
              order.OrderProductsList = order.OrderProductsList.map(product => {
                product.freightInputVisible = false;
                product.isChecked = false;
                product.freightInputValue = product.PostNumber;
                product.freightInputRef = "input" + product.OrderProductNumber;
                return product;
              });
              return order;
            });
          }
          console.log(res.data, "res.data");
          this.contents = res.data;

          // this.contents = res.data.map(item => {
          //   item.imageUrl = this.$api.formatImageUrl(item.ProductPhoto.split('|')[0])
          //   return item
          // })
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    nextPageAction() {
      this.request(this.state, this.page + 1);
    },
    previousPageAction() {
      this.request(this.state, this.page - 1);
    },
    stateChangeAction(state) {
      if (this.state === state) return;
      this.request(state, 1);
      this.selectedRow = [];
    },
    showPorductFreightAction(product) {
      product.freightInputVisible = true;
      this.$nextTick(_ => {
        this.$refs[product.freightInputRef][0].$refs.input.focus();
      });
    },
    productFreightInputConfirm(product) {
      const inputValue = product.freightInputValue;
      if (inputValue.length && inputValue !== product.PostNumber) {
        product.PostNumber = inputValue;
        this.$api.order.editOrderPostNumber({
          OrderProductNumber: product.OrderProductNumber,
          PostNumber: inputValue,
          OrderNumber: product.OrderNumber
        });
      }
      product.freightInputVisible = false;
    },
    printTagAction(product) {
      this.$api.order
        .createExpressLabel({
          OrderProductNumber: product.OrderProductNumber
        })
        .then(res => {
          this.tagImageSrc = res.data;

          this.dialogVisible = true;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    printTagImageAction() {
      console.log("打印");
      console.log(this.$print);
      console.log(this.$api);
      // this.$print(this.$refs.print)
    },
    // 跳转订单详情
    getProductInfo(orderNumber) {
      this.$router.push({
        path: "productInfo",
        query: { orderNumber: orderNumber }
      });
    },
    // 等待发货badge
    sendBadge() {
      const param = {
        PageIndex: 1,
        PageSize: 10,
        ScreenValues: 20
      };
      this.$api.order
        .loadOrderByPage(param)
        .then(res => {
          console.log(res, "res");
          this.sendCount = res.meta.total || null;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 等待买家付款badge
    waitBuyerPaymentCountBadge() {
      const param = {
        PageIndex: 1,
        PageSize: 10,
        ScreenValues: 10
      };
      this.$api.order
        .loadOrderByPage(param)
        .then(res => {
          this.waitBuyerPaymentCount = res.meta.total || null;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 已发货badge
    alreadySentCountBadge() {
      const param = {
        PageIndex: 1,
        PageSize: 10,
        ScreenValues: 30
      };
      this.$api.order
        .loadOrderByPage(param)
        .then(res => {
          this.alreadySentCount = res.meta.total || null;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 多选
    selectRow(event, orderNum, orderProductNum) {
      // 如果是选中
      if (event) {
        // 把选中的id存入数组
        this.selectedRow.push({
          OrderNumber: orderNum,
          OrderProductNumber: orderProductNum
        });
      } else {
        //如果是取消选中则从数组中删除该id
        // this.selectedRow.splice(this.selectedRow.indexOf(id), 1);
        const result = this.selectedRow.findIndex(
          item => item.OrderNumber === orderNum
        );
        this.selectedRow.splice(result, 1);
      }
      //console.log(this.roleCheck);
    },
    //关闭批量更新快递单号提示框
    cancelExpressDialogVisible() {
      this.updateExpressDialogVisible = false;
      this.mergeExpressNo = "";
      this.selectedRow = [];
    },
    // 确认批量更新
    updateExpress() {
      let param = {
        OrderNumberList: [...this.selectedRow],
        PostNumber: this.mergeExpressNo
      };
      this.$api.order
        .batchEditOrderPostNumber(param)
        .then(res => {
          // console.log(this.$refs[`checkBoxs${1}`][0]);
          this.$message.success(this.$t("B2B.success"));
          this.updateExpressDialogVisible = false;
          this.mergeExpressNo = "";
          this.selectedRow = [];
          this.request(this.state, 1);
          this.sendBadge();
          this.waitBuyerPaymentCountBadge();
          this.alreadySentCountBadge();
        })
        .catch(err => {
          this.$message.error(err);
          console.log(err);
        });
    },

    // 点击关闭订单按钮
    closeOrderBtn(num) {
      this.closeOrderNumber = num;
      this.closeOrderDialogVisible = true;
    },
    // cancelCloseOrderDialogVisible
    cancelCloseOrderDialogVisible() {
      this.closeOrderDialogVisible = false;
      this.resonForCloseOrder = "";
      this.closeOrderNumber = "";
    },
    confirmCloseOrderDialogVisible() {
      if (this.resonForCloseOrder == "") {
        return this.$message.error(this.$t("order.reason"));
      } else {
        const param = {
          OrderNumber: this.closeOrderNumber,
          OrderCancelReason: this.resonForCloseOrder
        };
        this.$api.order
          .cancelOrder(param)
          .then(res => {
            this.$message.success(this.$t("B2B.success"));
            this.request(this.state, 1);
            this.sendBadge();
            this.waitBuyerPaymentCountBadge();
            this.alreadySentCountBadge();
            this.closeOrderDialogVisible = false;
            this.resonForCloseOrder = "";
            this.closeOrderNumber = "";
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-orders {
  padding: 20px;
  .header-switch {
    ::v-deep .el-badge__content {
      height: 20px;
      width: 20px;
      padding: 0px;
    }
  }
  .table {
    margin-top: 28px;
    font-size: 12px;
    color: #333;
    p {
      margin: 0;
    }

    .layout {
      display: flex;
      align-items: center;

      .col-1 {
        flex: 1;
        width: 0;
      }

      .col-2 {
        flex: 2;
        width: 0;
      }

      .col-3 {
        flex: 3;
        width: 0;
      }
    }

    .table-header {
      border-top: 1px solid #eee;
      height: 40px;
      text-align: center;
    }

    .section {
      margin-bottom: 20px;
      border-bottom: 1px solid #d9ebe7;
      // border-radius: 30px;
      .header {
        background-color: #d9ebe7;
        border-radius: 30px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        display: flex;
        display: -webkit-flex;
        display: -webkit-inline-flex;
        display: -moz-flex;
        display: -ms-flex;
        width: 100%;

        span {
          margin-left: 10px;
          margin-right: 18px;
        }
        .allPrice {
          flex: 1;
          -webkit-flex: 1;
          text-align: right;
          .allPriceNum {
            font-size: 0.785rem;
            font-weight: bold;
            color: #000000;
            margin: 0 !important;
            padding: 0;
          }
          .allPriceTitle {
            font-size: 0.785rem;
            margin: 0 !important;
            padding: 0;
          }
        }
      }

      .row {
        height: 120px;

        & + .row {
          border-top: 1px solid #eee;
        }

        .product {
          display: flex;
          align-items: center;
          // padding: 0 15px;

          & > .img {
            flex: none;
            width: 66px;
            height: 66px;
            background-color: red;
            margin-left: 15px;
          }

          & > .content {
            flex: auto;
            margin-right: 15px;
            margin-left: 12px;
            position: relative;
            .class {
              margin: 8px 0 0;
              color: #999;
            }

            .id {
              margin: 4px 0 0;
              color: #999;
            }
            .title {
              color: #333;
            }
            .labelimg {
              position: absolute;
              top: 0;
              left: 8rem;
            }
          }
        }
        .price {
          color: #ff5852;
          text-align: center;
        }
        .count {
          text-align: center;
        }
        .buyer {
          text-align: center;
          color: #22b196;
          .detail {
            cursor: pointer;
            color: #25b9ff;
            margin-top: 10px;
            margin-bottom: 10px;
          }
          .freight {
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
          }
        }
        .state {
          text-align: center;

          .freight {
            cursor: pointer;
            color: #25b9ff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .detail {
            cursor: pointer;
            color: #25b9ff;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
        .money {
          text-align: center;
          .m {
            font-weight: bold;
          }
          .freight {
            margin-top: 6px;
          }
          .logistics {
            margin-top: 6px;
            color: #25b9ff;
            cursor: pointer;
          }
          .print {
            margin-top: 6px;
            color: #ff5852;
            cursor: pointer;
          }
        }
      }
    }

    .not-more-data {
      line-height: 50px;
      font-size: 12px;
      text-align: center;
      color: #999;
      background-color: #eee;
    }
  }
  .tag-image-dialog {
    .img {
      width: 430px;
      height: 325px;
      margin: 0 auto;
      display: block;
    }
    .btn-box {
      text-align: center;
      margin-top: 10px;
      .btn {
        width: 108px;
      }
    }
  }
  .noToPay {
    color: red;
    margin-top: 2px;
  }
}
</style>
